import ImgPerfilVazio from "../assets/img/perfil.jpg";

export const checkImg = (img) => {
  return img || ImgPerfilVazio;
};
